import { SectionHeader } from "@/components/sections/SectionHeader";
import { motion } from "framer-motion";
import { fadeInUp, staggerContainer, viewportConfig } from "@/lib/animations";

const principles = [
  "AI is a force multiplier, not a strategy",
  "Tools don't fix broken processes",
  "Visibility precedes velocity",
  "Control is more valuable than speed",
];

export const PhilosophySection = () => {
  return (
    <motion.section
      className="section-padding bg-secondary"
      initial="hidden"
      whileInView="visible"
      viewport={viewportConfig}
      variants={staggerContainer}
    >
      <div className="section-container">
        <div className="max-w-3xl mx-auto text-center">
          <motion.div variants={fadeInUp}>
            <SectionHeader
              eyebrow="How We Think"
              title="What is Operational Sovereignty?"
            />
          </motion.div>

          <motion.div
            className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-12"
            variants={staggerContainer}
          >
            {principles.map((principle, index) => (
              <motion.div
                key={index}
                className="bg-background border border-border p-6 text-left"
                variants={fadeInUp}
                whileHover={{ scale: 1.02, transition: { duration: 0.2 } }}
              >
                <span className="font-sans text-xs text-muted-foreground mr-3">
                  {String(index + 1).padStart(2, '0')}
                </span>
                <span className="font-serif text-lg text-foreground">
                  {principle}
                </span>
              </motion.div>
            ))}
          </motion.div>

          <motion.div className="divider mx-auto mb-8" variants={fadeInUp} />

          <motion.p
            className="font-serif text-2xl md:text-3xl text-foreground italic leading-relaxed"
            variants={fadeInUp}
          >
            We don't chase trends.
            <br />
            We design systems that survive them.
          </motion.p>
        </div>
      </div>
    </motion.section>
  );
};
